import { render } from "./Demo.vue?vue&type=template&id=66878950&scoped=true"
import script from "./Demo.vue?vue&type=script&lang=js"
export * from "./Demo.vue?vue&type=script&lang=js"

import "./Demo.vue?vue&type=style&index=0&id=66878950&scoped=true&lang=css"

import exportComponent from "/home/runner/work/demo-webapp/demo-webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66878950"]])

export default __exports__